






import Vue from 'vue'
import VimeoVideo from '@/components/video/VimeoVideo.vue'
export default Vue.extend({
  components: { VimeoVideo },
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      maxHeight: 0,
      vimeoId: null
    }
  },
  methods: {
    async getVideoId() {
      const video:firebase.firestore.DocumentSnapshot = await this.$db.collection("videos").doc(this.id).get()
      if (video.exists) {
        const videoData = video.data() || {}
        if (videoData.service === 'vimeo') {
          this.vimeoId = videoData.id
        }
      }
    },
    setMaxHeight() {
      const page:any = document.getElementById('app-page')
      this.maxHeight = page.offsetHeight
    }
  },
  created() {
    this.getVideoId()
  },
  mounted() {
    this.setMaxHeight()
    window.addEventListener('resize', () => {
      this.setMaxHeight()
    })
  }
})
